export const customFieldConstants = {

  GETALL_REQUEST: 'CUSTOM_FIELDS_GETALL_REQUEST',
  GETALL_SUCCESS: 'CUSTOM_FIELDS_GETALL_SUCCESS',
  GETALL_FAILURE: 'CUSTOM_FIELDS_GETALL_FAILURE',

  ADD_FIELD_REQUEST: 'NEW_CUSTOM_FIELD_REQUEST',
  ADD_FIELD_SUCCESS: 'NEW_CUSTOM_FIELD_SUCCESS',
  ADD_FIELD_FAILURE: 'NEW_CUSTOM_FIELD_FAILURE',

  DELETE_CUSTOM_FIELD_REQUEST: 'DELETE_CUSTOM_FIELD_REQUEST',
  DELETE_CUSTOM_FIELD_SUCCESS: 'DELETE_CUSTOM_FIELD_SUCCESS',
  DELETE_CUSTOM_FIELD_FAILURE: 'DELETE_CUSTOM_FIELD_FAILURE',

  GET_EDIT_CUSTOM_FIELD_REQUEST: 'GET_EDIT_CUSTOM_FIELD_REQUEST',
  GET_EDIT_CUSTOM_FIELD_SUCCESS: 'GET_EDIT_CUSTOM_FIELD_SUCCESS',
  GET_EDIT_CUSTOM_FIELD_FAILURE: 'GET_EDIT_CUSTOM_FIELD_FAILURE',

  PUT_EDIT_CUSTOM_FIELD_REQUEST: 'PUT_EDIT_CUSTOM_FIELD_REQUEST',
  PUT_EDIT_CUSTOM_FIELD_SUCCESS: 'PUT_EDIT_CUSTOM_FIELD_SUCCESS',
  PUT_EDIT_CUSTOM_FIELD_FAILURE: 'PUT_EDIT_CUSTOM_FIELD_FAILURE'

}



// WEBPACK FOOTER //
// ./src/constants/customfield.constants.js